var React = require('react');

function FacebookCircle (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","fill":"#fff","key":0},React.createElement("path",{"d":"m.00015 0h38v38h-38z","fill":"#fff","fillRule":"evenodd"})),React.createElement("path",{"d":"m23.32765 10.58935h-2.5155c-.8885 0-1.0735.364-1.0735 1.2825v2.22h3.589l-.3455 3.897h-3.2435v11.641h-4.6485v-11.592h-2.4175v-3.946h2.4175v-3.1075c0-2.9165 1.56-4.4395 5.019-4.4395h3.2185zm-5.3275-10.5895c-9.9415 0-18 8.0585-18 18s8.0585 18 18 18c9.941 0 18-8.0585 18-18s-8.059-18-18-18z","fill":"#fff","fillRule":"evenodd","mask":"url(#a)","key":1})]);
}

FacebookCircle.defaultProps = {"height":"36","viewBox":"0 0 36 36","width":"36"};

module.exports = FacebookCircle;

FacebookCircle.default = FacebookCircle;
